<template>
  <v-container class="legal">
    <article>
      <h1 class="legal-h1">{{ content.title }}</h1>
      <p v-if="content.intro" class="legal-intro" v-html="content.intro"></p>

      <nav v-if="content.sections.length > 6" class="legal-toc" aria-label="Inhaltsverzeichnis">
        <p class="legal-toc-title">Inhalt</p>
        <ol>
          <li v-for="section in content.sections" :key="section.id">
            <a :href="'#' + section.id">{{ section.title }}</a>
          </li>
        </ol>
      </nav>

      <section v-for="section in content.sections" :id="section.id" :key="section.id" class="legal-section">
        <h2>{{ section.title }}</h2>
        <template v-for="(block, index) in section.body">
          <ul v-if="block.list" :key="section.id + index">
            <li v-for="(item, itemIndex) in block.list" :key="itemIndex" v-html="item"></li>
          </ul>
          <p v-else :key="section.id + index" v-html="block"></p>
        </template>
      </section>

      <p class="legal-updated">Stand: {{ content.updated }}</p>
    </article>
  </v-container>
</template>

<script>
import publicPages from '@/content/publicPages';

// Impressum und Datenschutz – Texte kommen aus src/content/publicPages.js
export default {
  name: 'LegalPage',

  props: {
    page: {
      type: String,
      required: true,
      validator: v => ['impressum', 'datenschutz'].includes(v)
    }
  },

  computed: {
    content() {
      return publicPages[this.page];
    }
  }
};
</script>

<style scoped>
.legal {
  max-width: 820px;
  padding-top: 40px;
  padding-bottom: 72px;
  color: #1d2a1f;
}

.legal-h1 {
  margin-bottom: 12px;
  font-size: clamp(1.8rem, 3.5vw, 2.4rem);
  font-weight: 800;
  line-height: 1.2;
}

.legal-intro {
  color: #526255;
  font-size: 1.08rem;
  line-height: 1.7;
}

.legal-toc {
  margin: 24px 0 8px;
  padding: 18px 22px;
  border-radius: 12px;
  background: #f3f8f1;
}

.legal-toc-title {
  margin-bottom: 6px;
  font-weight: 700;
}

.legal-toc ol {
  margin: 0;
  column-gap: 32px;
  columns: 2;
}

.legal-toc a {
  color: #2e7d32;
  text-decoration: none;
}

.legal-toc a:hover {
  text-decoration: underline;
}

.legal-section {
  scroll-margin-top: 96px;
}

.legal-section h2 {
  margin: 36px 0 10px;
  font-size: 1.25rem;
  font-weight: 700;
}

.legal-section p,
.legal-section li {
  font-size: 1rem;
  line-height: 1.7;
}

.legal-section >>> a {
  color: #2e7d32;
}

.legal-updated {
  margin-top: 40px;
  color: #8a968c;
  font-size: 0.85rem;
}

@media (max-width: 600px) {
  .legal-toc ol {
    columns: 1;
  }
}
</style>
